// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"vy_a bhc_b","TwoDimsListFeature__item":"vy_b bhc_ux","TwoDimsListFeature__item__text":"vy_c bhc_un"};